export default "__VITE_ASSET__Pgvhd5Cn__"